import { useCallback } from 'react';
import { useGetEdges, useGetNodes } from '@/components/Recipe/FlowContext';
import { useWorkflowStore, type SaveRecipeOptions } from '@/state/workflow.state';

export const useSaveRecipe = () => {
  const saveRecipe = useWorkflowStore((state) => state.saveRecipe);
  const getNodes = useGetNodes();
  const getEdges = useGetEdges();

  return useCallback(
    async (options?: Omit<SaveRecipeOptions, 'getGraph'>, throwOnError = false) => {
      try {
        await saveRecipe({ ...(options || {}), getGraph: () => ({ nodes: getNodes(), edges: getEdges() }) });
      } catch (error) {
        if (throwOnError) {
          throw error;
        }
      }
    },
    [getEdges, getNodes, saveRecipe],
  );
};
